export const getFirstAdInsertionMessage = function (date: string): string {
  const monthAndYear = new Date(date).toLocaleDateString('it', {
    year: 'numeric',
    month: 'long',
  });

  return `Pubblica da ${monthAndYear
    .charAt(0)
    .toUpperCase()}${monthAndYear.slice(1)}`;
};

export const isProfileOwner = (ownerId: string, userId?: string): boolean =>
  ownerId === userId;
